import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class HttpLoadingService {
    private queries: string[] = [];
    public isLoading$ = new BehaviorSubject<boolean>(false);

    addQuery(query: string): void {
        if (!this.queries.includes(query)) {
            this.queries.push(query);
        }
        this.checkStatus();
    }

    removeQuery(query: string): void {
        const index = this.queries.indexOf(query);
        if (index > -1) {
            this.queries.splice(index, 1);
        }
        this.checkStatus();
    }

    checkStatus(): void {
        const isLoading = this.queries.length > 0;
        queueMicrotask(() => this.isLoading$.next(isLoading));
    }
}
